export default function FaqSection({ postSlug, faqs }) {
  if (!faqs || faqs.length === 0) return null;
  return (
    <section
      className="mt-20 md:mt-28 max-w-[900px] mx-auto px-6 md:px-0"
      data-testid="post-faq"
      aria-labelledby="faq-heading"
    >
      <div className="border-t border-white/10 pt-16">
        <p className="overline mb-4">Frequently Asked Questions</p>
        <h2
          id="faq-heading"
          className="font-serif-display text-3xl md:text-5xl text-white leading-[1.05] mb-10"
        >
          Answers, in brief.
        </h2>
        <dl className="divide-y divide-white/10">
          {faqs.map((f, i) => (
            <div key={`${postSlug}-faq-${i}`} className="py-8" data-testid={`faq-item-${i}`}>
              <dt className="font-serif-display text-xl md:text-2xl text-white mb-3 leading-snug">
                <span className="text-[var(--accent)] mr-3 text-lg">Q.</span>
                {f.question}
              </dt>
              <dd className="text-white/75 font-light leading-relaxed text-base md:text-lg pl-8">
                {f.answer}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
